﻿import $ from "jquery";
import "Fancybox";
import "slick";

export default function (options) {
	new DsZoomGallery(options);
}

class DsZoomGallery {
	constructor(options) {
		const _ = this;

		_.o = options;
		_.$ep = $(`#${_.o.entryPointId}`);

		if (_.$ep.length === 0) {
			return;
		}

		_.logCall = options.logCall;
		_.$slickMain = _.$ep.find(".ccs-ds-cloud-main-image");
		_.$slickThumbs = _.$ep.find(".ccs-ds-cloud-thumbs");

		_.initSlick();
		_.initFancybox();
	}

	initSlick() {
		const _ = this,
			isVerticalLayout = _.o.layout !== "bottom";

		_.$slickMain.ccsSlick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			speed: 200,
			draggable: false
		});

		_.slickMain = _.$slickMain.ccsSlick("getSlick");

		_.$slickThumbs.ccsSlick({
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 3,
			arrows: true,
			swipe: ccs_util.isMobile(),
			draggable: false,
			vertical: isVerticalLayout,
			verticalSwiping: isVerticalLayout
		});

		_.slickThumbs = _.$slickThumbs.ccsSlick("getSlick");
		$(_.slickThumbs.$slides.eq(0)).addClass("ccs-ds-cloud-current");

		const $image = _.slickMain.$slides.eq(0).find("img");

		$image.one("load", () => _.resize());

		if ($image[0].complete) {
			$image.trigger("load");
		}

		_.$slickMain.on("setPosition", () => _.resize());

		_.$slickMain.on("beforeChange", (event, slick, currentSlide, nextSlide) => _.switchActiveSlide(nextSlide));

		ccs_util.isMobile()
			? _.initMobileBehavior()
			: _.initDesktopBehavior();

		_.initTitle();

		if (_.slickMain.slideCount === 1) {
			_.$slickThumbs.addClass("ccs-hide");
		}
	}

	initTitle() {
		const _ = this;

		if (!_.o.displayTitle) {
			return;
		}

		_.$title = $("<div class='ccs-ds-title'>").appendTo(_.$slickMain);
		_.$title.html(_.slickMain.$slides.eq(0).data("caption"));

		_.$slickMain.on("afterChange", (event, slick, currentSlide) => {
			const $slide = _.slickMain.$slides.eq(currentSlide);
			_.$title.html($slide.data("caption"));
		});
	}

	initFancybox() {
		const _ = this;

		let config = {
			loop: true,
			buttons: ["zoom", "thumbs", "close"],
			baseClass: "ccs-fancybox-ds-cloud",
			animationEffect: "fade",
			thumbs: {
				autoStart: true
			},
			afterLoad(instance, current) {
				if (instance.currIndex === current.index && instance.firstRun) {
					const context = {
						position: current.index,
						url: current.src
					};
					_.submitEvent("zoom-in", context);
				}
			},
			beforeShow(instance, current) {
				if (instance.currIndex === instance.prevIndex)
					return;

				const context = {
					subelement: "lightbox",
					position: current.index,
					url: current.src
				};
				_.submitEvent("navigate-content", context);
			}, afterClose(instance, options) {
				_.switchActiveSlide(options.index);
			}
		};

		if (ccs_util.isMobile()) {
			const mobileConfig = {
				buttons: ["close"],
				thumbs: {
					autoStart: false
				}
			};
			config = $.extend(config, mobileConfig);
		}

		_.$ep.find(".ccs-fancybox-gallery").fancybox(config);
	}

	initDesktopBehavior() {
		const _ = this;
		let navOnHoverTimer;

		_.slickThumbs.$slides
			.on("mouseenter", (e) => {
				navOnHoverTimer = setTimeout(() => {
					const $current = $(e.currentTarget);
					const index = $current.data("slick-index");
					_.switchActiveSlide(index);
					_.submitNavigationEvent("hover", $current);
				}, 200);
			})
			.on("mouseleave", () => clearTimeout(navOnHoverTimer));
	}

	initMobileBehavior() {
		const _ = this;

		_.slickThumbs.$slides
			.on("click", (e) => {
				const $current = $(e.currentTarget);
				const index = $current.data("slick-index");
				_.switchActiveSlide(index);
				_.submitNavigationEvent("click", $current);
			});
	}

	switchActiveSlide(index) {
		const _ = this,
			$currentSlide = _.slickThumbs.$slides.eq(index),
			activeSlideClass = "ccs-ds-cloud-current";

		_.slickMain.goTo(index);
		const isHidden = _.slideIsHidden($currentSlide);

		if (isHidden) {
			_.slickThumbs.goTo(index);
		}

		_.slickThumbs.$slides
			.removeClass(activeSlideClass);
		$currentSlide
			.addClass(activeSlideClass);
	}

	resize() {
		const _ = this;

		const slidesInViewport = _.getSlidesInViewport();

		if (_.slickThumbs.getSlideCount() === slidesInViewport) {
			return;
		}

		_.slickThumbs.slickSetOption("slidesToShow", slidesInViewport);
		_.slickThumbs.slickSetOption("slidesToScroll", slidesInViewport);
		_.slickThumbs.refresh();
	}

	getSlidesInViewport() {
		const _ = this;

		return Math.max(Math.floor(_.o.layout !== "bottom"
			? _.slickMain.$list.height() / 52
			: _.slickThumbs.$list.width() / 52), 1);
	}

	slideIsHidden($slide) {
		const _ = this;
		const $slick = _.$slickThumbs;
		const $currentSlide = $slick.ccsSlick("getSlick").$slides.eq($slide.data("slick-index"));
		const slickOffset = $slick.offset();

		if (_.o.layout !== "bottom") {
			return slickOffset.top > $currentSlide.offset().top
				|| slickOffset.top + $slick.height() < $currentSlide.offset().top + $currentSlide.height();
		}

		return slickOffset.left > $currentSlide.offset().left
			|| slickOffset.left + $slick.width() < $currentSlide.offset().left + $currentSlide.width();
	}

	submitNavigationEvent(iteraction, $slide) {
		const _ = this;

		const actionContext = {
			position: $slide.data("slick-index"),
			url: $slide.data("original-src")
		};

		_.submitEvent(iteraction, actionContext);
	}

	submitEvent(iteraction, actionContext) {
		const _ = this;
		const logCall = _.logCall;

		ccs_cc_log.dispatchEvent(logCall, {
			Action: iteraction,
			ActionContext: JSON.stringify(actionContext)
		});
	}
}